<template>
  <v-card>
    <v-toolbar flat>
      <v-toolbar-title>科研项目绩效结果</v-toolbar-title>
    <span class="subheading ml-2">|</span>
    <v-spacer/>
      <v-text-field
        label="按项目负责人检索…"
        v-model="searchLeader"
        v-on:keyup.enter="onSearch"
        append-icon="search"
        :append-icon-cb="onSearch"
      />
      <v-text-field
        label="按项目所属部门检索…"
        v-model="searchDept"
        v-on:keyup.enter="onSearch"
        append-icon="search"
        :append-icon-cb="onSearch"
      />
    <v-text-field
      label="按项目类型检索…"
      v-model="searchType"
      v-on:keyup.enter="onSearch"
      append-icon="search"
      :append-icon-cb="onSearch"
    />
    </v-toolbar>
    <v-container>
      <v-layout row wrap align-content-start>
        <v-flex xs12 sm12 md5 lg5 xl4>
          <v-subheader style="display: inline">版本名称:</v-subheader>
          <v-btn-toggle v-model="editedItem.versionName" flat>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider/>
    <v-data-table
      :headers="headers"
      :loading="loading"
      :total-items="total"
      :pagination.sync="pagination"
      item-key="dbid"
      :items="items"
      no-data-text="没有数据。"
      no-results-text="没有符合条件的记录。"
    >
      <template slot="items" slot-scope="props">
        <td>
          {{ props.index + 1}}
        </td>
        <td>{{ props.item.batchName}}</td>
        <td>{{ props.item.projName}}</td>
        <td>{{ props.item.projLevelName }}</td>
        <td>{{ props.item.projTypeName }}</td>
        <td>{{ props.item.userName }}</td>
        <td>{{ props.item.deptName }}</td>
        <td>{{ props.item.projEntryDate }}</td>
        <td>{{props.item.approvalScore}}</td>
        <td>{{props.item.g1}}</td>
        <td>{{props.item.projCompletedDate}}</td>
        <td>{{props.item.concludingScore}}</td>
        <td>{{props.item.g2}}</td>
        <td>{{props.item.amount}}</td>
        <td>{{props.item.benchmark}}</td>
        <td>{{props.item.benchscore}}</td>
      </template>
      <!--<template slot="pageText" slot-scope="props">-->
      <!--显示第 {{props.pageStart}} - {{props.pageStop}} 条记录，共 {{props.itemsLength}} 条记录。-->
      <!--</template>-->
    </v-data-table>
  </v-card>
</template>
<script>
  export default {
    data() {
      return {
        searchLeader:'',
        searchDept:'',
        searchType:'',

        // 检索条件
        filters: {
          userName: '',
          projTypeName:'',
          deptName:''
        },
        // 分页条件
        pagination: {
          page: 1,
          rowsPerPage: 25,
          sortBy: 'projName.asc'
        },
        // 期刊表格
        headers: [
          {text: '#', align: 'left', sortable: false, value: 'dbid', width: "2rem"},
          {text: '批次', align: 'left', sortable: true, value: 'batchName'},
          {text: '项目名称', align: 'left', sortable: true, value: 'projName'},
          {text: '项目级别', align: 'left', sortable: true, value: 'projLevelName'},
          {text: '项目类型', align: 'left', sortable: true, value: 'projTypeName'},
          {text: '项目负责人', align: 'left', sortable: true, value: 'userName'},
          {text: '项目负所属部门', align: 'left', sortable: true, value: 'deptName'},
          {text: '立项时间', align: 'left', sortable: false, value: 'projEntryDate'},
          {text: '立项基准绩效点', align: 'left', sortable: false, value: 'approvalScore'},
          {text: '立项绩效点', align: 'left', sortable: false, value: 'g1'},
          {text: '结项时间', align: 'left', sortable: false, value: 'projCompletedDate'},
          {text: '结项基准绩效点', align: 'left', sortable: false, value: 'concludingScore'},
          {text: '结题绩效点', align: 'left', sortable: false, value: 'g2'},
          {text: '到款经费', align: 'left', sortable: false, value: 'amount'},
          {text: '经费基准', align: 'left', sortable: false, value: 'benchmark'},
          {text: '经费绩效点', align: 'left', sortable: false, value: 'benchscore'}
        ],

        loading: false,
        total: 0,
        pagination: {},
        items: [],

        editedItem: {
          "versionName":"",
          "batchName": "",
          "projName": "",
          "projLevelName":"",
          "projTypeName":"",
          "userName":"",
          "deptName":"",
          "projEntryDate":"",
          "approvalScore":"",
          "projCompletedDate":"",
          "concludingScore":"",
          "amount":"",
          "benchmark":"",
          "g1":"",
          "g2":"",
          "benchscore":""
        },
        defaultItem: {
          "versionName":"",
          "batchName": "",
          "projName": "",
          "projLevelName":"",
          "projTypeName":"",
          "userName":"",
          "deptName":"",
          "projEntryDate":"",
          "approvalScore":"",
          "projCompletedDate":"",
          "concludingScore":"",
          "amount":"",
          "benchmark":"",
          "g1":"",
          "g2":"",
          "benchscore":""
        },
      }
    },
    created() {
      // 组件创建完后获取数据，
      // 此时 data 已经被 observed 了
    },
    watch: {
      // 如果路由有变化，会再次执行该方法
      '$route': 'get',
      pagination: {handler: 'get', deep: true},
      filters: {
        deep: true,
        handler: function () {
          if (this.pagination.page !== 0) {
            this.pagination.page = 0;
          } else {
            this.get();
          }
        }
      }
    },

    methods: {
      // 检索响应函数
      onSearch() {
        this.filters.userName = this.searchLeader;
        this.filters.deptName = this.searchDept;
        this.filters.projTypeName = this.searchType;
        if (this.pagination.page === 0)
          this.get();
        else
          this.pagination.page = 0
      },

      paginationParams(p) {
        let params = {};
        if (p.sortBy) {
          params.sort = p.sortBy + (p.descending ? '.desc' : '.asc')
        }
        if (p.page) {
          params.page = p.page - 1
        }
        if (p.rowsPerPage) {
          params.limit = p.rowsPerPage
        }
        return params;
      },
      // 获取列表
      get() {
        window.console.log(JSON.stringify(this.query));
        const vm = this;
        const params = Object.assign(
          window.xutil.paramsPagination(vm.pagination),
          window.xutil.paramsFilters(vm.filters)
        );
        vm.loading = true;
        this.axios.get('/api/perf/projectScore/', {params: params})
          .then(rsp => {
            vm.loading = false;
            vm.items = rsp.data.items;
            vm.total = rsp.data.total;
          })
      }
    }
  }
</script>
<style scoped>
  div.toolbar__content div.input-group {
    margin-left: 1em;
  }
</style>
